import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrossCircleBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCrossCircleBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M1 4.5A2.5 2.5 0 0 1 3.5 2h13A2.5 2.5 0 0 1 19 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 15.5zM13.5 10a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m1.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-3.47-1.53a.75.75 0 0 1 0 1.06l-.53.53.53.53a.75.75 0 1 1-1.06 1.061l-.53-.53-.531.53a.75.75 0 0 1-1.06-1.06l.53-.53-.53-.53a.75.75 0 0 1 1.06-1.062l.53.53.53-.53a.75.75 0 0 1 1.061 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrossCircleBox20);
